/* Klaviyo acquisition popup opener.

   The acquisition form is configured in Klaviyo to NOT display
   automatically, and this script is the only thing that opens it. At most
   one acquisition popup per session, one per cooldown window.

   2026-09-14 (Caleb, "disable the texas popup"): the Texas split is
   retired. Every visitor now gets the standard form. The Texas form
   'Rm6JJU' is never opened, and the per-visitor geo lookup that fed the
   split is gone with it — this script now requests and stores no location
   of any kind. To bring the split back, restore the /geo fetch and route
   confirmed-Texas visitors to that form id.

   2026-11-03: first-order offer pause. The list of sale windows lives in
   layout/theme.liquid (window.__bskOfferPause, computed before this script
   runs); while a window is active this script does nothing at all, and in
   particular writes neither latch key. The finder teaser reads the same
   object and pauses with it.

   Nothing here may ever break the storefront: every storage access is
   wrapped, and if Klaviyo never initializes the queued open is simply
   inert. */
(function () {
  'use strict';

  /* ── configuration ─────────────────────────────────────────────── */
  const DEFAULT_KLAVIYO_FORM_ID = 'UTwAYc';

  /* ── sale override (Labor Day 2026) ── self-scheduling: active only
     inside the window below (client clock), so no push is needed at either
     boundary — before the start and after the end the router behaves
     normally. While active: ONE form for every visitor — supersedes the
     Texas split AND the cooldown window, so people who recently saw an
     acquisition popup still get the sale once. The session latch stays
     (once per session, never every page), and opening stamps the cooldown
     clock so normal pacing resumes cleanly after the window. Clean up the
     consts whenever after Sept 8. */
  const SALE_FORM_ID = 'SRZwcc';
  const SALE_START_MS = Date.parse('2026-09-02T10:00:00Z'); /* 4:00 AM Denver, Sept 2 */
  const SALE_END_MS = Date.parse('2026-09-08T05:59:59Z');   /* sale end — matches the discounts */

  const POPUP_COOLDOWN_DAYS = 7;

  /* ── finder teaser ── THE single switch (2026-09-23).
     The New Customer Finder teaser carries the same first-order offer as this
     popup. Where the teaser is on the page it owns the offer and the popup
     stands down, so a visitor is never pitched the same 20% twice. The popup
     stays live everywhere the teaser is not.
     Set to false to run the two side by side. Nothing in the teaser's own
     markup decides this — the teaser only marks itself. */
  const TEASER_SUPPRESSES_POPUP = true;
  const TEASER_SELECTOR = '[data-bsk-finder-teaser]';

  const DEBUG = false;

  const SESSION_LATCH_KEY = 'bs_klaviyo_popup_opened'; /* sessionStorage: '1' */
  const LAST_SEEN_KEY = 'bs_klaviyo_popup_last_seen';  /* localStorage: epoch ms */

  function log(msg, extra) {
    if (DEBUG) console.log('[Klaviyo Router] ' + msg, extra === undefined ? '' : extra);
  }

  /* double-execution guard (section reloads, duplicate script tags) */
  if (window.__bskKlaviyoRouter) return;
  window.__bskKlaviyoRouter = true;

  if (window.location.pathname.indexOf('/apps/portal') === 0) return;

  /* Never pitch a first-order offer to someone who has already ordered.
     FIRST20 is restricted to a zero-order segment, so a returning buyer
     shown this popup would be handed a code checkout will refuse — worse
     than not showing it. Set from Liquid, so it only resolves while the
     customer is signed in; the discount's own segment is what actually
     enforces eligibility for everyone else. */
  if (window.__bskHasPurchased === true) { log('Known purchaser — no acquisition popup'); return; }
  if (window.__bskWholesaleHome === true) { log('Wholesale homepage — no acquisition popup'); return; }

  /* ── first-order offer pause ── window.__bskOfferPause is computed once in
     layout/theme.liquid, where THE list of sale windows lives (read here and
     by the finder teaser alike). While a window is active nothing below runs:
     no open, and neither latch key is written, so the 7-day cooldown is not
     spent on a popup nobody saw. ?bs_popup_now= on the URL simulates the time
     for that check only. */
  const pause = window.__bskOfferPause;
  if (pause && pause.paused === true) { log('Sale pause active — no acquisition popup'); return; }

  function sget(store, key) { try { return window[store].getItem(key); } catch (e) { return null; } }
  function sset(store, key, val) { try { window[store].setItem(key, val); } catch (e) {} }

  /* ── gates shared by both forms ── */
  if (sget('sessionStorage', SESSION_LATCH_KEY) === '1') { log('Session latch active'); return; }

  /* The teaser stamps the same two latches it would have stamped by opening,
     so pacing downstream (cooldown, once-per-session) behaves identically
     whichever surface carried the offer. */
  if (TEASER_SUPPRESSES_POPUP && document.querySelector(TEASER_SELECTOR)) {
    sset('sessionStorage', SESSION_LATCH_KEY, '1');
    sset('localStorage', LAST_SEEN_KEY, String(Date.now()));
    log('Finder teaser on the page — popup stands down');
    return;
  }

  /* sale mode: no geo, no cooldown — everyone gets the sale form once per
     session (openForm is hoisted; its don't-stack check still applies) */
  if (SALE_FORM_ID && Date.now() >= SALE_START_MS && Date.now() < SALE_END_MS) {
    log('Sale override active');
    openForm(SALE_FORM_ID);
    return;
  }

  const last = parseInt(sget('localStorage', LAST_SEEN_KEY) || '0', 10);
  if (last && Date.now() - last < POPUP_COOLDOWN_DAYS * 86400000) { log('Cooldown active'); return; }

  function openForm(formId) {
    /* the acquisition form is script-controlled, so a visible Klaviyo form
       here means something already engaged the visitor — don't stack,
       and don't burn the cooldown (we didn't show anything) */
    const other = document.querySelector('.klaviyo-form');
    if (other && other.offsetParent !== null) { log('Another Klaviyo form is already visible'); return; }
    if (!window._klOnsite && !window.klaviyo) log('Klaviyo unavailable');
    window._klOnsite = window._klOnsite || [];
    log('Opening form: ' + formId);
    window._klOnsite.push(['openForm', formId]);
    sset('sessionStorage', SESSION_LATCH_KEY, '1');
    sset('localStorage', LAST_SEEN_KEY, String(Date.now()));
  }

  openForm(DEFAULT_KLAVIYO_FORM_ID);
})();
